import {
  IconBrandAxios,
  IconBrandExpress,
  IconBrandLogo,
  IconBrandTanstack,
  IconBrandZod,
  IconBrandZustand,
  IconSubmarine
} from "@/app/(root)/components/custom-icons";
import {
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertTriangle,
  IconArrowBigUpLines,
  IconArrowRight,
  IconBlocks,
  IconBook,
  IconBookmark,
  IconBookmarkPlus,
  IconBookmarks,
  IconBrandCss3,
  IconBrandFirebase,
  IconBrandGithub,
  IconBrandHtml5,
  IconBrandJavascript,
  IconBrandLinkedin,
  IconBrandMongodb,
  IconBrandNextjs,
  IconBrandNodejs,
  IconBrandPython,
  IconBrandReact,
  IconBrandSupabase,
  IconBrandTailwind,
  IconBrandThreads,
  IconBrandTypescript,
  IconBrandWhatsapp,
  IconBriefcase,
  IconBuildings,
  IconCalendarMonth,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircleCheck,
  IconCirclePlus,
  IconCircleX,
  IconClearAll,
  IconCloudUpload,
  IconCode,
  IconCodePlus,
  IconCommand,
  IconCopyright,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeClosed,
  IconFileOff,
  IconFiles,
  IconFileTypePdf,
  IconFilter,
  IconFilter2,
  IconFolderCog,
  IconFolderOpen,
  IconFolderPlus,
  IconGripVertical,
  IconHeartFilled,
  IconLayoutDashboard,
  IconLibraryPhoto,
  IconLogout,
  IconMail,
  IconMapPin,
  IconMinus,
  IconMoon,
  IconPalette,
  IconPhoto,
  IconPhotoOff,
  IconPlus,
  IconProps,
  IconRss,
  IconSearch,
  IconSelector,
  IconSort09,
  IconSort90,
  IconSortAscending2,
  IconSortAscendingLetters,
  IconSortAZ,
  IconSortDescending2,
  IconSortDescendingLetters,
  IconSortZA,
  IconSun,
  IconTrash,
  IconUserCircle,
  IconWorldWww,
  IconX,
  IconXboxX
} from "@tabler/icons-react";

export type Icon = React.ComponentType<IconProps>;

export const Icons = {
  add: IconPlus,  
  adjustment: IconAdjustmentsHorizontal,
  alertCircle: IconAlertCircle,
  alertTriangle: IconAlertTriangle,
  arrowRight: IconArrowRight,
  arrowUp: IconArrowBigUpLines,
  asc2: IconSortAscending2,
  blocks: IconBlocks,
  book: IconBook,
  bookmark: IconBookmark,
  bookmarks: IconBookmarks,
  bookmarkPlus: IconBookmarkPlus,
  brandAxios: IconBrandAxios,
  brandCss: IconBrandCss3,
  brandFirebase: IconBrandFirebase,
  brandExpress: IconBrandExpress,
  brandHtml: IconBrandHtml5,
  brandJavascript: IconBrandJavascript,
  brandLogo: IconBrandLogo,
  brandMongoDb: IconBrandMongodb,
  brandNextJs: IconBrandNextjs,
  brandNodejs: IconBrandNodejs,
  brandPython: IconBrandPython,
  brandReact: IconBrandReact,
  brandSupabase: IconBrandSupabase,
  brandTailwind: IconBrandTailwind,
  brandTanstack: IconBrandTanstack,
  brandTypescript: IconBrandTypescript,
  brandZod: IconBrandZod,
  brandZustand: IconBrandZustand,
  briefcase: IconBriefcase,
  building: IconBuildings,
  calendar: IconCalendarMonth,
  check: IconCheck,
  circleCheck: IconCircleCheck,
  chevronDown: IconChevronDown,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronUp: IconChevronUp,
  circlePlus: IconCirclePlus,
  clearAll: IconClearAll,
  close: IconX,
  closeCircle: IconCircleX,
  code: IconCode,
  codePlus: IconCodePlus,
  copyright: IconCopyright,
  dashboard: IconLayoutDashboard,
  desc2: IconSortDescending2,
  download: IconDownload,
  error: IconXboxX,
  edit: IconEdit,
  eye: IconEye,
  eyeClosed: IconEyeClosed,
  externalLink: IconExternalLink,
  file: IconFileTypePdf,
  files: IconFiles,
  fileOff: IconFileOff,
  filter: IconFilter,
  folders: IconFolderOpen,
  folderCog: IconFolderCog,
  folderPlus: IconFolderPlus,
  github: IconBrandGithub,
  gripVertical: IconGripVertical,
  home: IconWorldWww,
  imageOff: IconPhotoOff,
  letterAsc: IconSortAscendingLetters,
  letterDesc: IconSortDescendingLetters,
  linkedin: IconBrandLinkedin,
  location: IconMapPin,
  logo: IconCommand,
  logout: IconLogout,
  love: IconHeartFilled,
  mail: IconMail,
  minus: IconMinus,
  moon: IconMoon,
  palette: IconPalette,
  photo: IconPhoto,
  photos: IconLibraryPhoto,
  plus: IconPlus,
  rss: IconRss,
  selector: IconSelector,
  search: IconSearch,
  sort: IconFilter2,
  sortAZ: IconSortAZ,
  sortZA: IconSortZA,
  sort09: IconSort09,
  sort90: IconSort90,
  submarine: IconSubmarine,
  sun: IconSun,
  threads: IconBrandThreads,
  trash: IconTrash,
  upload: IconCloudUpload,
  user2: IconUserCircle,
  verticalDots: IconDotsVertical,
  whatsapp: IconBrandWhatsapp,
};
